/**
 * The explorer's data access.
 *
 * It uses the package's typed client, so the browser speaks the same DTOs as
 * the server and the SDK. No pricing type is redefined here.
 */

import { createPricingClient } from "@pricing/client";

export const client = createPricingClient({ baseUrl: "" });

export type { PricingClient } from "@pricing/client";
